export const SET_HYDRATION_STATUS = (state, bool) => {
    state.hasHydration = bool;
};

export const SET_SHOW_NEED_EDIT_MODAL = (state, bool) => {
    state.editModalIsOpen = bool;
};

export const SET_SHOW_CONFIRM = (state, bool) => {
    state.confirmModalIsOpen = bool;
}

export const SET_PROGRAM = (state, payload) => {
    state.program = payload;
};

export const isFetchingProgram = (state) => {
    state.isFetchingProgram = true;
};

export const finishedFetchingProgram = (state) => {
    state.isFetchingProgram = false;
};

export const SET_ACTIVE_NEED = (state, payload) => {
    state.activeNeed = payload;
};

export const UPDATE_CHECKED_NEEDS = (state, payload) => {
    state.coachCheckedNeeds = payload;
};

export const SET_SELECTED_NEEDS = (state, payload) => {
    state.coachSelectedNeeds = payload;
};

export const POP_NEW_NEED = (state, payload) => {
    state.program.needs = payload;
};

export const SET_CREATING_NEEDS = (state, bool) => {
    state.isCreatingNeeds = bool;
};

export const SET_IS_SAVING_CRITERIA = (state, bool) => {
    state.isSavingCriteria = bool;
};

export const SET_IS_DELETING_NEED = (state, bool) => {
    state.isDeletingNeed = bool;
};


export const SET_IS_PUBLISHING_NEEDS = (state, bool) => {
    state.isPublishingNeeds = bool;
};

export const SET_IS_REDIRECTING = (state, bool) => {
    state.isRedirecting = bool;
};